

exports.__esModule = true;
exports.$AddNationalIdRoute = undefined;

require('./directive');

var _squid = require('squid');

var $AddNationalIdRoute = exports.$AddNationalIdRoute = _squid.$ComponentRoute.extend('$AddNationalIdRoute', {

    path: 'addNationalId',

    directive: 'xo-add-national-id-page',

    titleContent: 'addTaxId.nationalityUpdate',

    children: []
});

angular.value("$AddNationalIdRoute", $AddNationalIdRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-national-id/route.js
// module id = ./pages/xo-add-national-id/route.js
// module chunks = 1